// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { saveLoadFactory, SaveLocation } from 'application-storage';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IClaimOrder } from './../../businessLogic/sagas/serviceRequest/types';
import { logPageAction } from 'src/lib/ApplicationInsights';

interface PropType {
    claim: IClaimOrder;
}

export default function PrintReceipt ({ claim }: PropType) {
    const { t } = useTranslation();
    const warranties = useSelector((state: any) => state.device.warranties);

    const claimStorage = saveLoadFactory('claim', SaveLocation.LocalStorage);
    const warrantiesStorage = saveLoadFactory('warranties', SaveLocation.LocalStorage);
    
    const printReceiptLink = `${location.origin}/printReceipt`;
    
    function onClick (e: React.MouseEvent) {
        logPageAction('Print receipt link clicked');

        claimStorage.setValue(claim);
        warrantiesStorage.setValue(warranties);
        e.stopPropagation();
    }

    return (
        <div onClick={onClick}>
            <a href={printReceiptLink} target="_blank">
                {t('view_or_print_your_receipt')}
            </a>
        </div>
    );
}